import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/context/LangContext";
import Seo from "@/components/Seo";

export default function About() {
  const { t } = useLang();
  return (
    <div data-testid="about-page" className="mx-auto max-w-7xl px-6 pb-28 pt-32 sm:px-10 lg:px-16">
      <Seo title={t("seo.aboutTitle")} description={t("seo.about")} />
      <Reveal>
        <p className="eyebrow">{t("about.eyebrow")}</p>
        <h1 className="mt-4 max-w-3xl font-serif text-4xl font-light leading-tight text-bone sm:text-5xl lg:text-6xl">
          {t("about.title")}
        </h1>
      </Reveal>

      <div className="mt-16 grid gap-16 lg:grid-cols-2">
        <Reveal delay={0.1}>
          <div className="space-y-6 text-sm leading-relaxed text-bone-dim/85 sm:text-base">
            <p className="font-serif text-2xl font-light italic leading-snug text-bone">
              {t("about.quote")}
            </p>
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
            <p>{t("about.p3")}</p>
            <div className="pt-6">
              <p className="font-cursive text-5xl text-bone">DeMoivre</p>
              <p className="mt-2 font-mono text-[9px] tracking-[0.35em] text-brass">
                {t("brand.subtitleCaps")}
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1758901810612-55ba2c317a53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxhcnQlMjBzdHVkaW8lMjBwYWludGluZyUyMGNhbnZhcyUyMGdhbGxlcnklMjBkYXJrJTIwbHV4dXJ5fGVufDB8fHx8MTc4ODgwNjU5NHww&ixlib=rb-4.1.0&q=85"
              alt="L'atelier — toiles en préparation"
              className="aspect-[4/5] w-full border border-bone/10 object-cover"
              loading="lazy"
            />
            <span className="tick" style={{ top: 10, left: 10 }} />
            <span className="tick" style={{ bottom: 10, right: 10 }} />
            <p className="mt-4 flex justify-between font-mono text-[9px] tracking-[0.25em] text-bone-muted">
              <span>{t("about.imageCaption")}</span>
              <span className="text-brass">FIG. A</span>
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal className="mt-24 border-t border-bone/10 pt-16 text-center">
        <p className="font-serif text-2xl font-light italic text-bone-dim sm:text-3xl">
          {t("about.closing1")}<br />{t("about.closing2")}
        </p>
        <Link
          data-testid="about-shop-cta"
          to="/shop"
          className="group mt-10 inline-flex items-center gap-3 border border-brass/60 bg-brass/10 px-10 py-4 font-mono text-[11px] tracking-[0.35em] text-brass transition-all duration-300 hover:bg-brass hover:text-ink"
        >
          {t("about.cta")}
          <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
  );
}
